import axios from 'axios';
import { serviceRequestEndpoint } from '../config';
import getHeaders from '../utils/getHeaders';
import { logger } from '../logger';

const log = logger();

const createServiceRequest = async (payload) => {
  try {
    const response = await axios.post(
      `${serviceRequestEndpoint}/patients/service-requests`,
      payload,
      getHeaders(),
    );
    return response.data;
  } catch (err) {
    log.error('Error creating service request', err);
    throw err;
  }
};

const serviceRequestService = {
  createServiceRequest,
};

export default serviceRequestService;
